import React, { useState } from 'react';
import useReveal from '../hooks/useReveal';

export default function Contact() {
  useReveal();
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = e => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="page">
      <div className="ph rv">
        <div className="s-label">Get In Touch</div>
        <h1>Let's Build Something<br />Production-Ready</h1>
        <p className="lead">Have a project in mind? Looking to improve your backend systems or automate workflows? We'd love to hear about it.</p>
      </div>

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="wrap">
          <div className="contact-grid">

            {/* Left — methods */}
            <div className="rv">
              <div className="s-label" style={{ marginBottom: '1.2rem' }}>Contact Options</div>
              <h2 style={{ fontFamily: 'var(--font)', fontSize: '1.9rem', fontWeight: 800, letterSpacing: '-.04em', color: 'var(--white)', marginBottom: '1rem', lineHeight: 1.1 }}>
                Get In Touch
              </h2>
              <p style={{ fontSize: '.9rem', color: 'var(--muted)', lineHeight: 1.75, marginBottom: '2rem' }}>
                We typically respond within 24 hours. For project inquiries, the form helps us prepare so we can skip the basics and get straight to engineering.
              </p>

              <div className="c-methods">
                <a href="mailto:contact@arhatinfo.com" className="c-method">
                  <div className="c-ico">📧</div>
                  <div>
                    <div className="c-key">Email</div>
                    <div className="c-val">contact@arhatinfo.com</div>
                  </div>
                  <span className="c-arr">→</span>
                </a>
                <a href="#calendly" className="c-method">
                  <div className="c-ico">📅</div>
                  <div>
                    <div className="c-key">Schedule a Call</div>
                    <div className="c-val">Book a free 30-min consultation</div>
                  </div>
                  <span className="c-arr">→</span>
                </a>
              </div>

              <div className="s-label" style={{ marginBottom: '1rem' }}>Also Available On</div>
              <div className="platforms">
                {[
                  ['💼', 'Upwork',          'Full project or hourly',  'https://www.upwork.com/agencies/1795937132490870784/'],
                  ['🎯', 'Fiverr',          'Packaged services',       'https://fiverr.com'],
                  ['💻', 'Direct Contract', 'Long-term engagement',    '#contact'],
                ].map(([ico, name, desc, href]) => (
                  <a key={name} href={href} target={href.startsWith('http') ? '_blank' : undefined} rel="noreferrer" className="p-row">
                    <span className="p-ico">{ico}</span>
                    <span className="p-name">{name}</span>
                    <span className="p-desc">{desc}</span>
                    <span style={{ color: 'var(--dim)' }}>→</span>
                  </a>
                ))}
              </div>
            </div>

            {/* Right — form */}
            <div className="rv d1">
              <div className="form-box">
                {submitted ? (
                  <div style={{ textAlign: 'center', padding: '2rem 0' }}>
                    <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
                    <h3 style={{ fontFamily: 'var(--font)', fontSize: '1.4rem', fontWeight: 800, color: 'var(--white)', marginBottom: '.8rem' }}>
                      Message received!
                    </h3>
                    <p style={{ color: 'var(--muted)', fontSize: '.9rem' }}>
                      We'll get back to you within 24 hours. Talk soon!
                    </p>
                  </div>
                ) : (
                  <>
                    <div className="form-title">Tell us about your project</div>
                    <div className="form-sub">Fill this out and we'll come prepared to your first call.</div>

                    <div className="rsp-box">
                      <span className="pdot" />
                      <span>We respond within 24 hours, typically faster.</span>
                    </div>

                    <form onSubmit={handleSubmit}>
                      <div className="form-grid">
                        <div className="field">
                          <label>Your Name</label>
                          <input type="text" placeholder="Jane Smith" required />
                        </div>
                        <div className="field">
                          <label>Company / Project</label>
                          <input type="text" placeholder="Acme Corp" />
                        </div>
                        <div className="field">
                          <label>Email Address</label>
                          <input type="email" placeholder="jane@acme.com" required />
                        </div>
                        <div className="field">
                          <label>Service Needed</label>
                          <select defaultValue="">
                            <option value="" disabled>Select a service...</option>
                            {['Backend Development','AI & LLM Integration','AI Document Processing','Cloud & DevOps','Workflow Automation','Data Engineering','Not sure — let\'s discuss'].map(o => (
                              <option key={o}>{o}</option>
                            ))}
                          </select>
                        </div>
                        <div className="field full">
                          <label>Tech Stack (if any)</label>
                          <input type="text" placeholder="e.g. Django, PostgreSQL, AWS — or leave blank" />
                        </div>
                        <div className="field full">
                          <label>Project Overview</label>
                          <textarea placeholder="What are you building? What problem needs solving? What's the current situation?" required />
                        </div>
                        <div className="field">
                          <label>Timeline</label>
                          <select defaultValue="">
                            <option value="" disabled>When do you need this?</option>
                            {['ASAP','Within 1 month','1–3 months','3–6 months','Flexible'].map(o => <option key={o}>{o}</option>)}
                          </select>
                        </div>
                        <div className="field">
                          <label>Budget (optional)</label>
                          <select defaultValue="">
                            <option value="" disabled>Approximate budget</option>
                            {['Under $2,000','$2,000 – $5,000','$5,000 – $15,000','$15,000+','Prefer to discuss'].map(o => <option key={o}>{o}</option>)}
                          </select>
                        </div>
                      </div>
                      <p className="form-note">Your information is never shared with third parties.</p>
                      <button type="submit" className="submit-btn">Send Project Inquiry →</button>
                    </form>
                  </>
                )}
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}
